import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import 'semantic-ui-css/semantic.min.css';

var container = document.getElementById('root');
if (container) {
  var root = createRoot(container);
  root.render(<App />);
}